import React, { useContext, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { mainContext } from '../../context/context';
// import styles from './ClientHistory.module.scss'
import styles2 from "./../InformationsForms/InformationFormsStyle.module.scss";
import Loading from '../Loader/Loading';
import Button from '../../components/ReusableElements/Button/Button';
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from "../../common/constants";
import FormButtons from '../InformationsForms/FormButtons';
import _axios from '../../utils/api/_axios';
import { Content } from 'antd/es/layout/layout';
import { Card, Col, Form, List, Modal, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';

const ClientHistory = ({ patientId, claimId }, ref) => {
    const { notes, getNotesData, isLoading } = useContext(mainContext)
    const [isAddingNote, setIsAddingNote] = React.useState(false);
    const [newNotes, setNewNotes] = React.useState("");
    const childMethod = (patientId, claimId) => {
        getNotesData(patientId, claimId);
    }
    useEffect(() => {
        getNotesData(patientId, claimId);
    }, [])
    const handleNotesChange = (e) => {
        setNewNotes(e.target.value);
    };
    const openAddNotes = () => {
        setIsAddingNote(true);
    };

    const closeAddNotes = () => {
        setIsAddingNote(false);
        setNewNotes("");
    };
    const handleSubmit = async (e) => {
        e.preventDefault()
         
        try {
            const addClaim = claimId ? `/claim/${claimId}` : "";
            const historyNote = {
                descriptions: [newNotes]
            };
            const response = await _axios.post(
                `${baseUrl}/history/patient/${patientId}${addClaim}`,
                historyNote,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    cache: "no-cache"
                }
            );
            if (response.status === 201) {
                getNotesData(patientId, claimId)
                toast.success("Note added successfully");
                setNewNotes("");
            } else {
                toast.error("Failed.");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to update history.");
        }
    };

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        };
        return new Date(dateString).toLocaleString(undefined, options);
    };

    // Use useImperativeHandle to expose childMethod to the parent component
    useImperativeHandle(ref, () => ({
        childMethod,
    }));
    return (
        <>
        {isLoading && (
          <div className="flex justify-center items-center">
            <Loading isCircular={true} />
          </div>
        )}
      
        <div className="max-w-lg w-full p-0">
          {!isAddingNote && (
            <div className="mb-4">
              <Button onClick={openAddNotes} buttonText="Add Note" />
            </div>
          )}
      
          {isAddingNote ? (
            <Modal
              title="Add Note"
              wrapClassName="vertical-center-modal"
              open={isAddingNote}
              onOk={closeAddNotes}
              onCancel={closeAddNotes}
            >
              <div>
                <form name="notes" onSubmit={handleSubmit}>
                  <div className="bg-white shadow-md rounded-lg p-4">
                    <div className="mb-4">
                      <label htmlFor="note" className="block text-lg font-bold text-gray-800">
                        Note
                      </label>
                      <textarea
                        rows={3}
                        className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={newNotes}
                        onChange={handleNotesChange}
                        placeholder="Enter your notes here..."
                      />
                    </div>
      
                    {/* <div className="flex justify-end">
                      <FormButtons handleClose={closeAddNotes} />
                    </div> */}
                  </div>
                </form>
                <hr className="border-dashed border-gray-500 my-4" />
              </div>
            </Modal>
          ) : (
            <div></div>
          )}
        </div>
      
        {notes?.length > 0 &&
          notes?.map((note, index) => (
            <div key={index} className="bg-white shadow-md rounded-lg p-4 mb-4">
              <div className="text-lg font-semibold text-gray-900">{note.title || ""}</div>
              <ul className="list-disc pl-5 text-gray-700">
                {note?.descriptions?.length > 0 &&
                    note?.descriptions?.map((description, i) => (
                        <li key={i}>
                            {typeof description === 'object' ? JSON.stringify(description) : description}
                        </li>
                    ))}
              </ul>
              <div className="italic text-sm text-gray-600">
                Posted by {note.createdBy || "Admin"} on {formatDate(note.createdAt || "")}
              </div>
            </div>
          ))}
      </>
      
    );
}

export default forwardRef(ClientHistory);